import React, { memo } from "react";

import { useTranslation } from "utils";

import { COVER_CROP_TYPE_OPTIONS, CROP_DETAILS_COVER_CROP_FIELDS } from "consts";

import { SoilSightCoverCropDefaults } from "models";

import { Option, Select } from "components";

import { HelpFieldWrapper } from "pages/app/scenario-analysis/components/HelpFieldWrapper";
import { CropDetailsNumberField } from "pages/app/scenario-analysis/components/crop-details-input-context-drawer/CropDetailsNumberField";
import { CropDetailsFieldGuidance } from "pages/app/scenario-analysis/hooks/useCropDetailsGuidance";

interface CoverCropSectionProps {
  initialCoverCropId: string | null | undefined;
  hasCoverCrop: boolean;
  /** Values the cover crop inputs show when they mount; follows the cover crop type, never the typing. */
  coverCropInitialValues: SoilSightCoverCropDefaults;
  guidance: CropDetailsFieldGuidance;
}

export const CoverCropSection = memo(({ initialCoverCropId, hasCoverCrop, coverCropInitialValues, guidance }: CoverCropSectionProps) => {
  const { t } = useTranslation("scenarioAnalysis");
  const { onFocus, getFieldLabel, getUnitSuffix } = guidance;

  return (
    <section className="crop-details-drawer-section-card">
      <div className="crop-details-drawer-section-card-heading">{t("cropDetailsDrawer.section.coverCrop")}</div>

      <HelpFieldWrapper fieldKey="coverCropId" onFocus={onFocus}>
        <Select
          name="coverCropId"
          label={getFieldLabel("coverCropId")}
          tooltip={t("scenarioBuilder.coverCropTimingTooltip")}
          initialValue={initialCoverCropId ?? undefined}
        >
          {COVER_CROP_TYPE_OPTIONS.map((opt) => (
            <Option key={opt.value} value={opt.value}>
              {t(opt.labelKey)}
            </Option>
          ))}
        </Select>
      </HelpFieldWrapper>

      {hasCoverCrop && (
        <div className="crop-details-drawer-cover-crop-fields">
          {CROP_DETAILS_COVER_CROP_FIELDS.map((field) => (
            <CropDetailsNumberField
              key={field.name}
              field={field}
              label={getFieldLabel(field.name)}
              suffix={getUnitSuffix(field.name)}
              initialValue={coverCropInitialValues[field.name]}
              onFocus={onFocus}
            />
          ))}
        </div>
      )}
    </section>
  );
});
